/**
 * Vendor imports
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'centstoeuros',
    standalone: true,
})
export class CentsToEurosPipe implements PipeTransform {
    /**
     * Returns the given number converted in euros
     * Example : converts number 2003 to number 20,03 €
     * Example : converts number 2000 to number 20 €
     * @param {number} value Amount in cents to convert in euros
     * @returns {number} Amount in euros
     */
    public transform(value: number, displayDecimals?: boolean): string {
        let converted: string;
        if (value || value === 0) {
            if (String(Math.round(value) / 100).split('.').length > 1) {
                converted = (Math.round(value) / 100).toFixed(2) + ' €';
            } else if (displayDecimals) {
                converted = (Math.round(value) / 100).toFixed(2) + ' €';
            } else {
                converted = Math.round(value) / 100 + ' €';
            }
            return converted.replace('.', ',');
        } else {
            return '';
        }
    }
}
